'use strict';

import ngResource from 'angular-resource';

class DeviceStatusService {
    constructor($resource) {
        'ngInject';

        this.api = $resource(
            '/api/device_status', {},
            { index : { method:'GET', isArray: true } }
        )
    }
}

export default angular.module('leptonApp.DeviceStatusService', ['ngResource'])
    .service('DeviceStatusService', ['$resource', DeviceStatusService])
    .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/device_status/device_status.service.js